import { supabase } from '../supabase';
import type { Category, MenuItem } from '../types';

export async function loadMenu(tenantId: string): Promise<{ categories: Category[]; items: MenuItem[] }> {
  const [cats, items] = await Promise.all([
    supabase
      .from('categories')
      .select('id, name, name_local, image_url, display_order, is_active')
      .eq('tenant_id', tenantId)
      .eq('is_active', true)
      .order('display_order', { ascending: true }),
    supabase
      .from('menu_items')
      .select('id, category_id, name, name_local, description, description_local, image_url, base_price, vat_rate, is_available, display_order, tags')
      .eq('tenant_id', tenantId)
      .eq('is_available', true)
      .order('name', { ascending: true }),
  ]);

  if (cats.error)  throw cats.error;
  if (items.error) throw items.error;

  return {
    categories: (cats.data ?? []) as Category[],
    items:      (items.data ?? []) as MenuItem[],
  };
}
